import { render, staticRenderFns } from "./BaseWizard.vue?vue&type=template&id=2c8ae382&"
import script from "./BaseWizard.vue?vue&type=script&lang=js&"
export * from "./BaseWizard.vue?vue&type=script&lang=js&"
import style0 from "./BaseWizard.vue?vue&type=style&index=0&id=2c8ae382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports